export enum LocalStorageItems {
  mixpanelConsent = "load_and_go.mixpanelConsent",
  driverId = "load_and_go.driverId",
  vehicleId = "load_and_go.vehicleId",
}
